import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, TextField, DialogActions, Button, Switch, Alert, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { NotificationTemplate } from '../../../interfaces/delivery-company/orders';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import axios, { AxiosResponse } from 'axios';
import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
interface AddNoteDialogProps {
    onSubmit: (template: string) => Promise<AxiosResponse>
    onClose: () => void;
    onSuccess: (template: string) => void;
    availableTemplates?: NotificationTemplate[];
    setSnackBarResult: (t?: timestampedMessage) => void;
}

function AddNotesDialog({ onSubmit, onSuccess, onClose, availableTemplates, setSnackBarResult }: AddNoteDialogProps) {
    const [notificationTemplate, setNotificationTemplate] = useState<string>()
    const [useCustomMessage, setUseCustomMessage] = useState(false)
    const [response, setResponse] = useState<AxiosResponse>()
    const [message, setMessage] = useState<string>("")
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setNotificationTemplate("")
    }, [useCustomMessage])

    const handleSubmit = async () => {
        setSnackBarResult(undefined)
        setIsLoading(true)
        if (!notificationTemplate) {
            setSnackBarResult({
                content: "Message has no content",
                level: 'error',
                timestamp: Date.now()
            })
            setIsLoading(false)
            return
        }
        try {
            setSnackBarResult(undefined)
            const response = await onSubmit(notificationTemplate)
            setResponse(response)
            setSnackBarResult({
                content: "Notes Added",
                level: 'success',
                timestamp: Date.now()
            })
            onSuccess(notificationTemplate)
            onClose()
        } catch (e) {
            const msg = "Failed to add notes"
            if (axios.isAxiosError(e)) {
                setResponse(e.response)
                setMessage(msg + ": " + e.response?.statusText)
            } else {
                setMessage(msg)
            }
            setSnackBarResult({
                content: msg,
                level: 'error',
                timestamp: Date.now()
            })
        }
        setIsLoading(false)
    }

    return (
        <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
            < DialogTitle > Add notes</DialogTitle >
            <DialogContent>
                {
                    isLoading ? <>Adding notes... <br /> <CircularProgress /></> : <>
                        {message != '' &&
                            <>
                                <Alert
                                    severity={
                                        response && response.status >= 200 && response.status < 300
                                            ? 'success'
                                            : 'error'
                                    }
                                >
                                    <>
                                        {message}

                                        {response &&
                                            response.status >= 300 &&
                                            <ErrorsFlattenner rawErrors={response.data} />
                                        }
                                    </>
                                </Alert>
                                <br />

                            </>
                        }
                        {(
                            <TextField
                                autoComplete="off"
                                fullWidth
                                value={notificationTemplate}
                                onChange={(e) => setNotificationTemplate(e.target.value)}
                                margin="normal"
                                label="New Note"
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        )}
                    </>
                }

            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} disabled={isLoading || notificationTemplate == undefined || notificationTemplate.length == 0} color="primary">Save</Button>
            </DialogActions>


        </CustomDialog>
    );
}

export default AddNotesDialog;